import React from "react";
import "./ExpenseChartBar.css";

const ExpenseChartBar = (props) => {
    let barHeight = "0%";

    if (props.maxValue > 0) {
        barHeight = Math.round((props.value / props.maxValue) * 100) + "%";
    }

    return (
        <div className="chart-bar">
            <div className="chart-bar__inner">
                <div
                    className="chart-bar__fill"
                    style={{ height: barHeight }}
                ></div>
            </div>
            <div className="char-bar__label">{props.label}</div>
        </div>
    );
};

export default ExpenseChartBar;
